import { useEffect, useState } from "react";
import { useBlock } from "@/lib/content";
import { getConsent } from "@/lib/consent";

// Injects Google Analytics 4 when a Measurement ID is configured in Site settings
// AND the visitor has granted cookie consent.
export default function AnalyticsLoader() {
  const settings = useBlock("settings", null);
  const ga4 = settings && settings.analytics ? settings.analytics.ga4 : null;
  const [consent, setConsent] = useState(getConsent());

  useEffect(() => {
    const h = (e) => setConsent(e.detail);
    window.addEventListener("cli-consent", h);
    return () => window.removeEventListener("cli-consent", h);
  }, []);

  useEffect(() => {
    if (!ga4 || consent !== "granted" || window.__ga4_loaded) return;
    window.__ga4_loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", ga4);
  }, [ga4, consent]);

  return null;
}
